export const deleteScheduleCollaboratorInitialState = {
	deleted: null,
	error: null,
	errorShow: false,
	loading: false,
};
